import React from "react";
import TitleImg from "../../images/top__title.png";
import './ClosedPage.scss';

export const ClosedPage = () => {
    return <div className='closed'>
        <div className="closed__content-flex-container">
            <div className='closed__content'>
                <div className='closed__title'><img src={TitleImg} width={434} height={330} alt=""/></div>
                <div className='closed__text-1'>We're not recruiting right now.</div>
                <div className='closed__text-2'>ただいまの期間は募集を行っておりません。</div>
                <div className='closed__text-3'>過去のプロジェクトは<br/>&gt;<a href='https://hikarino-mi.jp'>こちら</a>からご覧いただけます。</div>
            </div>
        </div>
    </div>
};